/* eslint-disable */

export default {
  init() {
    // scripts here run on the DOM load event
  },
  finalize() {
    // scripts here fire after init() runs

    const config = {
      root: null, // avoiding 'root' or setting it to 'null' sets it to default value: viewport
      rootMargin: '-50% 0% -50% 0%',
      threshold: 0
    };

    //check to see if there is more than one cover-component on this page
    var allCovers = $('#main').find('.cover'); 


    let isLeaving = false;
    let observer = new IntersectionObserver(function(entries) {
      
        entries.forEach(entry => {

            if (entry.isIntersecting) {
              // we are ENTERING the "capturing frame". Set the flag.
              isLeaving = true;
              console.log('in view');
              var videoElementContainer = entry.target;
              var video = $(videoElementContainer).find('video');
              video.trigger('play');


                  // Do something with entering entry
            } else if (isLeaving) {
              // we are EXITING the "capturing frame"
              isLeaving = false;
              // Do something with exiting entry
            }
          });
          
    }, config);

    allCovers.each(function() {
        observer.observe($( this )[ 0 ]);

    });


  },
};



// WEBPACK FOOTER //
// ./scripts/components/cover.js